import { Box, Divider } from '@mui/material'
import ProjectCost from './ProjectCost'
import SpacialDesignScore from './SpacialDesignScore'
import MaterialBreakdown from './MaterialBreakdown'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchTakeOffCalculationAsync } from '../../../services/takeOffService'
import { setIsTakeOffCalculationInProgress } from '../../../actions/takeOff'

const TakeOffBreakdown = () => {
  const dispatch = useDispatch<any>()

  useEffect(() => {
    const abortController = new AbortController()

    dispatch(setIsTakeOffCalculationInProgress(true))
    dispatch(fetchTakeOffCalculationAsync({ signal: abortController.signal }))

    return () => {
      dispatch(setIsTakeOffCalculationInProgress(false))
      abortController.abort()
    }
  }, [dispatch])

  return (
    <Box
      sx={{
        borderRadius: '4px',
        border: '1px solid #E9E9E9',
        flexBasis: '250px',
        maxHeight: '250px',
        backgroundColor: '#FFF',
        boxShadow: '0px 2.642px 4.403px 0px rgba(47, 47, 47, 0.25)',
        padding: 2,
        display: 'flex',
        gap: '12px',
        margin: '12px 12px 0px 12px',
      }}
    >
      <Box sx={{ display: 'flex' }}>
        <ProjectCost />

        <SpacialDesignScore />
      </Box>

      <Divider
        flexItem
        orientation='vertical'
        sx={{
          backgroundColor: '#EFEFEF',
        }}
      />

      <MaterialBreakdown />
    </Box>
  )
}

export default TakeOffBreakdown
